import { Button, Icon, useToast } from "@chakra-ui/react";
import { ArrowsClockwise } from "@phosphor-icons/react";
import React, { useState } from "react";
import { iconSize } from "../../const/sizes";
import useTrigger from "../../globalState/useTrigger";
import cr from "../../lib/request";

type Props = {
  id: number;
};

export default function SwitchAdminAccountStatus({ id }: Props) {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const onSwitchStatus = () => {
    setLoading(true);
    const url = `api/account/${id}/switchstatus`;
    cr.post(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: "Status admin berhasil diubah",
            description: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Status admin gagal diubah",
          description: e.response?.data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      onClick={onSwitchStatus}
      variant={"ghost"}
      colorScheme="ap"
      className="clicky"
      leftIcon={<Icon as={ArrowsClockwise} fontSize={iconSize} />}
      isLoading={loading}
    >
      Status
    </Button>
  );
}
